<arm-dialog [title]="'Advanced Search'" (onCancel)="onCancel()" (onSubmit)="onSubmit()">
    <div class="search-container">
        <div class="search-column">
            <mat-form-field>
                <mat-label>Name</mat-label>
                <input [(ngModel)]="search.name" matInput>
            </mat-form-field>

            <ac-input-container label="Administrative State">
                <ac-select [(acModel)]="search['administrative state']"
                           [allowClear]="true"
                           [items]="search.adminStateOptions">
                </ac-select>
            </ac-input-container>

            <ac-input-container label="Operative State" >
                <ac-select [(acModel)]="search['operative state']"
                           [multiple]="true"
                           [items]="search.operStateOptions" >
                </ac-select>
            </ac-input-container>

            <ac-input-container label="Elements">
                <ac-select [(acModel)]="search.elements"
                           [multiple]="true"
                           [items]="search.elementsOptions">
                </ac-select>
            </ac-input-container>

        </div>
    </div>
</arm-dialog>
